import React, { ButtonHTMLAttributes } from 'react';
import { LoadingDots } from '../../utilities/Utilities';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonText: string;
  isLoading: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  buttonText,
  isLoading,
  disabled,
  className,
  onClick,
  ...rest
}) => {
  return (
    <button
      disabled={disabled || isLoading}
      className={`button-primary !text-white !font-semibold ${className && 'w-fit'}${
        disabled ? 'disabled:bg-[#968368] disabled:cursor-not-allowed' : ''
      }`}
      onClick={isLoading ? undefined : onClick}
      {...rest}
    >
      {isLoading ? <LoadingDots /> : buttonText}
    </button>
  );
};

export default Button;
